// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7gR6f","label":"styles_label__1em6W"};